(function () {
  function getThemeTokens() {
    const root = document.documentElement;
    const cs = getComputedStyle(root);
    const pick = (name, fallback) => cs.getPropertyValue(name).trim() || fallback;

    const richText =
      document.querySelector('.rich-text__text.text-subtext') ||
      document.querySelector('.rich-text__text.rte');
    const bodyText = richText ? getComputedStyle(richText) : getComputedStyle(document.body);
    return {
      height: pick('--buttons-height', '4.8rem'),
      paddingInline: pick('--buttons-padding', '3.2rem'),
      radius: pick('--buttons-radius', '10rem'),
      borderWidth: pick('--buttons-border-width', '1px'),
      bg: `rgb(${pick('--color-button', '108, 135, 62')})`,
      text: `rgb(${pick('--color-button-text', '255, 255, 255')})`,
      fontFamily: pick('--font-button-family', 'Montserrat, sans-serif'),
      fontWeight: pick('--font-button-weight', '600'),
      fontSize: pick('--font-body-size', '15px'),
      letterSpacing: pick('--buttons-letter-spacing', '0'),
      textTransform: pick('--buttons-transform', 'capitalize'),
      animationButton: pick('--animation-button', '0.3s'),
      linkColor: `rgb(${pick('--color-link', '7, 40, 53')})`,
      bodyColor: bodyText.color,
      bodyFontFamily: bodyText.fontFamily,
      bodyFontSize: bodyText.fontSize,
      bodyFontWeight: bodyText.fontWeight,
      bodyFontStyle: bodyText.fontStyle,
      bodyLineHeight: bodyText.lineHeight,
      bodyLetterSpacing: bodyText.letterSpacing,
    };
  }

  function applyWiderrufsformStyles() {
    const host = document.querySelector('shopify-forms-embed#app-embed');
    if (!host?.shadowRoot) return false;

    const t = getThemeTokens();
    const padding = `0 ${t.paddingInline}`;

    host.style.setProperty('--button-border-radius', t.radius, 'important');
    host.style.setProperty('--button-padding', padding, 'important');
    host.style.setProperty('--button-background-color', t.bg, 'important');
    host.style.setProperty('--button-text-color', t.text, 'important');
    host.style.setProperty('--button-border', '0px solid transparent', 'important');
    host.style.setProperty('--forms-accent-color', t.linkColor, 'important');
    host.style.setProperty('--forms-text-color', t.bodyColor, 'important');

    const btn = host.shadowRoot.querySelector('button[data-testid="btn-form-submit"]');
    if (btn && !btn.querySelector('.btn__text')) {
      const label = btn.textContent.trim();
      btn.textContent = '';
      const text = document.createElement('span');
      text.className = 'btn__text';
      text.textContent = label;
      btn.appendChild(text);
    }

    let style = host.shadowRoot.getElementById('gruenday-form-theme');
    if (!style) {
      style = document.createElement('style');
      style.id = 'gruenday-form-theme';
      host.shadowRoot.appendChild(style);
    }

    style.textContent = `
      form p,
      form span:not(.btn__text),
      form [class*="textBody"],
      form [class*="formDisclaimer"],
      form [class*="helpText"],
      form [class*="description"] {
        color: ${t.bodyColor} !important;
        font-family: ${t.bodyFontFamily} !important;
        font-size: ${t.bodyFontSize} !important;
        line-height: ${t.bodyLineHeight} !important;
        font-weight: ${t.bodyFontWeight} !important;
        font-style: ${t.bodyFontStyle} !important;
        letter-spacing: ${t.bodyLetterSpacing} !important;
        -webkit-font-smoothing: antialiased !important;
        -moz-osx-font-smoothing: grayscale !important;
      }
      form input,
      form textarea,
      form select {
        font: revert !important;
        color: revert !important;
        line-height: revert !important;
        letter-spacing: revert !important;
      }
      button[data-testid="btn-form-submit"] {
        box-sizing: border-box !important;
        position: relative !important;
        z-index: 1 !important;
        overflow: hidden !important;
        display: inline-flex !important;
        align-items: center !important;
        justify-content: center !important;
        width: 100% !important;
        max-width: 100% !important;
        height: ${t.height} !important;
        min-height: ${t.height} !important;
        padding: ${padding} !important;
        margin: 0 !important;
        border: ${t.borderWidth} solid ${t.bg} !important;
        border-radius: ${t.radius} !important;
        background-color: ${t.bg} !important;
        color: ${t.text} !important;
        font-family: ${t.fontFamily} !important;
        font-weight: ${t.fontWeight} !important;
        font-size: ${t.fontSize} !important;
        line-height: 30px !important;
        letter-spacing: ${t.letterSpacing} !important;
        text-transform: ${t.textTransform} !important;
        cursor: pointer !important;
        outline: none !important;
        outline-offset: 0 !important;
        box-shadow: none !important;
        filter: none !important;
        -webkit-appearance: none !important;
        appearance: none !important;
        transition: background 0.3s, color 0.3s !important;
      }
      button[data-testid="btn-form-submit"]::before {
        content: "" !important;
        position: absolute !important;
        width: 0 !important;
        inset-block: -0.1rem !important;
        inset-inline-start: -0.1rem !important;
        background-color: ${t.text} !important;
        transition: width ${t.animationButton} !important;
        border-radius: inherit !important;
        z-index: 0 !important;
      }
      button[data-testid="btn-form-submit"] .btn__text {
        position: relative !important;
        z-index: 1 !important;
        overflow: hidden !important;
        text-overflow: ellipsis !important;
      }
      button[data-testid="btn-form-submit"]:focus-visible {
        filter: none !important;
        box-shadow: none !important;
        outline: none !important;
      }
      @media (hover: hover) and (pointer: fine) {
        button[data-testid="btn-form-submit"]:hover::before {
          width: calc(100% + ${t.borderWidth}) !important;
        }
        button[data-testid="btn-form-submit"]:hover {
          color: ${t.bg} !important;
          background-color: ${t.bg} !important;
          border: ${t.borderWidth} solid ${t.bg} !important;
          filter: none !important;
          box-shadow: none !important;
        }
      }
      form a {
        color: ${t.linkColor} !important;
        text-underline-offset: 0.3rem !important;
        text-decoration-thickness: 0.1rem !important;
        text-decoration-line: underline !important;
      }
      form a:hover {
        text-decoration-thickness: 0.2rem !important;
      }
    `;

    host.shadowRoot.appendChild(style);

    return true;
  }

  function init() {
    if (applyWiderrufsformStyles()) return;

    const observer = new MutationObserver(function () {
      applyWiderrufsformStyles();
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
